export default __webpack_public_path__ + "static/media/FamilyField400.28de1818.jpg";